module.exports = __webpack_public_path__ + "static/media/Image_Loading_Placeholder_Large.6ae88eff.png";